import React from 'react';
import { Helmet } from 'react-helmet-async';
import News from './News';

const News_en = () => (
  <div className="lang-en">
    <Helmet>
      <title>News</title>
      <meta
        name="description"
        content="Read the latest Tang Wu Biotech news, food safety updates, certifications, and global catering ingredient developments."
      />
      <meta name="keywords" content="news, food safety, industry updates" />
    </Helmet>
    <News />
  </div>
);

export default News_en;
